import { useDispatch, useSelector } from "react-redux";
import { deleteSiteAccessRestriction } from "../../../../../Api Methods/Api";
import { scheduled } from "rxjs";
import classes from '../EditAutomations/IFTTTRuleLayout.module.css'
import { useEffect, useRef, useState } from "react";
import Modal from "../../../../Modal/Modal";
import arrowIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Page - Forward.svg"
import Button2 from "../../../Button/Button2";
import { it } from "date-fns/locale";
import { format } from "date-fns";
import Pill_Widget from "../../../Widgets/Pill_Widget";
import RuleCard from "../../Rules/RuleCard";

const AccessRestrictionLayout = ({item, fetchAutomations}) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

    const startTime = item.startTime
    const endTime = item.endTime
    const days = item.days
    const scheduleID = item.id

    const showRemoveScheduleButton = true;
    const apiData = {
        token,
        client
    }

    const createdBy = item.createdBy
    const dateCreated = item.dateCreated;

    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }

        //reset model screens
        HandelResetModal();
    }

    
    const [modalComponent, setModalComponent] = useState()
    //--------------------------------------------------------------------------------------------
    const [modalPageIndex, setModalPageIndex] = useState(null);

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setModalPageIndex(null);
    }

    
    const dispatch = useDispatch();

    const DeleteRestriction = async () => {
        const response = await deleteSiteAccessRestriction(scheduleID, apiData, dispatch);
        if (response && response.success) {
            HandleCloseModal();
            fetchAutomations();
        }
    }

    const sortedDays = () => {
        const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

        if (!item || !item.days) return "";

        const rawDays = typeof item.days === "string" ? JSON.parse(item.days) : item.days;

        const selectedDayNames = rawDays.map(dayNumber => Days[Number(dayNumber)]).join(',');

        if (rawDays.length === 7) {
            return "everyday";
        } else if (selectedDayNames === "Mon,Tue,Wed,Thu,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
            return "on weekends";
        } else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    };

    const EditAutomation = () => {
        setModalComponent(
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px', // Spacing between buttons
                padding: '15px',
                width: '100%', // Adjust width as needed
                background: 'white',
                borderRadius: '8px',
                alignContent:"center",
                alignItems:"center"
                }}>
                {/* { isRuleAppliedToInput && <Button1 style={{ width: '100%', height:'45px' }} onClick={() => setIsAutomationActive((prevIsAutomationActive) => (prevIsAutomationActive == true ? 0 : 1))}>{isAutomationActive ? "De-activate rule" : "Activate rule" }</Button1>} */}
                    <Button2 style={{ 
                                minWidth: "350px", 
                                minHeight: "50px", 
                                display: "flex", 
                                justifyContent: "center", 
                                alignItems: "center",
                                color:"#ff5c5c"
                            }}
                            onClick={() => DeleteRestriction()}>Delete restriction
                    </Button2>
                    <br></br>
                    <Button2 style={{ 
                                minWidth: "350px", 
                                minHeight: "50px", 
                                display: "flex", 
                                justifyContent: "center", 
                                alignItems: "center"
                            }} 
                            onClick={HandleCloseModal}>Cancel
                    </Button2>
                </div>
        );
        
        HandleShowModal();
    }


    return (
        <>
            <Modal ref={ModalDialog} title={"Edit"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "200px", minHeight: "120.5px"}} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            <RuleCard
                 header={`Access restriction`}
                 onClick={() => EditAutomation()}
                 meta={[`Site access is allowed ${sortedDays()}, between ${item.startTime} and ${item.endTime} `]}
                 rightContent={
                    <>
                        <Pill_Widget height={{ height: "25px" }} boolean={true} PillColor_IfTrue={"var(--Active-color)"} PillColor_IfFalse={"var(--Inactive-color)"} text_IfTrue={"Active"} text_IfFalse={"Inactive"} className={classes.PillHeight} />
                    </>
                 }
                footer={
                    createdBy && dateCreated
                      ? `Created by ${createdBy.fullName} on ${format(
                          new Date(dateCreated),
                          "MMM do, yyyy - HH:mm"
                        )}`
                      : null
                  }                 />


            
        </>
    )
}

export default AccessRestrictionLayout;